import { Box } from '@mui/material';
import React from 'react';
import { Title } from 'react-admin';
import { useParams } from 'react-router-dom';

import { BackToLaunches } from './BackToLaunches';
import { LaunchWizard } from './LaunchFlow';

const LaunchPage: React.FC = () => {
  const { id = '' } = useParams();
  return (
    <Box marginTop={2}>
      <Title title="Launch Manager" />
      <BackToLaunches />
      <LaunchWizard launchId={id} />
    </Box>
  );
};

export default LaunchPage;
